import { OfferUI } from 'common/contracts';
import { AnyObjectSchema } from 'yup';

import { GeneralThemeFormValues } from 'components/Theme/GeneralSettings/generalTheme.types';
import { StoreThemeFormValues } from 'components/Theme/StoreTheme/storeTheme.types';

export enum OfferDesignTypes {
  SpecialOffer = 'SpecialOffer',
  Bundle = 'Bundle',
  PopUp = 'PopUp',
  RollingOffer = 'RollingOffer',
  ProgressBar = 'ProgressBar'
}

export interface OfferDesignRow {
  _id: string;
  name: string;
  externalId: string;
  backgroundImage?: string;
  offerUiType: string;
  createdAt: string;
}

export interface OfferDesignActions {
  onEdit: (id: string, offerUiType: string) => void;
  onDuplicate: (id: string, offerUiType: string) => void;
  onDelete: (id: string) => void;
}

export interface OfferDesignPermissions {
  canUserEdit: boolean;
  canManage: boolean;
}

export interface FilterCriteria {
  externalId: string;
  name: string;
  types: string[];
}

export interface OfferTypeCardConfig {
  key: string;
  title: string;
  description: string;
  image: string;
  offerDesignType: OfferDesignTypes;
  subType?: string;
  disabled?: boolean;
}

export interface GradientColor {
  colorOne: string;
  colorTwo?: string;
  gradientDirection?: string;
}

export interface OfferDesignFormValues {
  name: string;
  externalId: string;
  backgroundImage: string;
  backgroundColor: string;
  offerUiType: OfferDesignTypes;
}

export interface ProgressBarFormValues {
  name: string;
  externalId: string;
  backgroundOpacity: number;
  frameRadius: number;
  barFillColor: GradientColor;
  barBackgroundColor: GradientColor;
  barRadius: number;
  borderColor: GradientColor;
  borderWidth: number;
  accumulatedItemImageUrl: string;
  textColor: string;
}

export interface OfferDesignFormikProps {
  values: Record<string, any>;
  errors: Record<string, string | undefined>;
  touched: Record<string, boolean | undefined>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  setFieldValue: (field: string, value: unknown) => void;
}

export type RenderCardFn = (
  values: Record<string, any>,
  generalTheme: GeneralThemeFormValues,
  storeScreen: StoreThemeFormValues
) => React.ReactNode;

export interface OfferTypeFormConfig {
  FormFields: React.FC<OfferDesignFormikProps & {
    isNameUnique: boolean;
    isExternalIdUnique: boolean;
    shouldDisplaySubTitle?: boolean;
  }>;
  schema: AnyObjectSchema;
  buildPayload: (formValues: Record<string, any>, offerType: OfferDesignTypes) => OfferUI;
}
